import { createFileRoute, notFound } from '@tanstack/react-router';

import { grantListDeps, loadGrantList } from '../features/grants/list-loader';
import { GrantTypePage, grantTypeHead } from '../features/grants/type-page';
import { programKindFromSlug, programKindPath } from '../features/grants/type-routes';
import { grantTypeSearch } from '../features/grants/type-search';

/**
 * `/news/programs/<slug>` — 프로그램 하위 종류 목록 (learning · networking · contests · fairs · sales · overseas · other).
 * 종류는 주소가 정한다. 모르는 조각이면 404. 옛 `/programs?kind=` 는 server.mjs 가 여기로 301.
 */
export const Route = createFileRoute('/news/programs/$kind')({
  validateSearch: grantTypeSearch,
  loaderDeps: ({ search }) => grantListDeps(search),
  loader: async ({ params, context, deps }) => {
    const kind = programKindFromSlug(params.kind);
    if (!kind) throw notFound();
    return { kind, ...(await loadGrantList(context, deps, { support: 'program', kind })) };
  },
  head: ({ loaderData }) =>
    loaderData ? grantTypeHead('program', programKindPath(loaderData.kind), loaderData.kind) : {},
  component: () => {
    const { kind, ...loaded } = Route.useLoaderData();
    return (
      <GrantTypePage type="program" kind={kind} path={programKindPath(kind)} filters={Route.useLoaderDeps()} loaded={loaded} />
    );
  },
});
